/** Accessible initial fallback while the router loads a feature chunk. */
export function RouteLoading() {
  return (
    <p role="status" className="text-slate-body p-6 text-center text-sm">
      در حال بارگذاری صفحه…
    </p>
  );
}
